import { render } from "./StaffPerformanceScores.vue?vue&type=template&id=a5367ce4&scoped=true&ts=true"
import script from "./StaffPerformanceScores.vue?vue&type=script&lang=ts"
export * from "./StaffPerformanceScores.vue?vue&type=script&lang=ts"

import "./StaffPerformanceScores.vue?vue&type=style&index=0&id=a5367ce4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5367ce4"]])

export default __exports__